export const setLocalStorageFilters = (objName, value) => {
    /**
     * Function that will set local storage filters/sortBy for a certain data table.
     * Local storage key will have the data table name and the filters or sortBy.
     * Parent calling this function must send the correct value. (sortBy and filters should have 2 different keys. 1 sortBy - Table)
     */
    if (value === "") {
        localStorage.removeItem(objName);
        return;
    }

    localStorage.setItem(objName, value);
};
export const getLocalStorageFilter = (objName) => {
    return localStorage.getItem(objName) ? localStorage.getItem(objName) : null;
};



// WEBPACK FOOTER //
// ./src/components/common/LocalStorageFilters/LocalStorageFilters.js